var authorization = require('../services/authorization');
var router = require('../services/router');

var messages = require('../components/messages');
var preloader = require('../components/preloader');

var Quote = require('./Quote');

var Quotes = function () {
    var self = this;

    var full_list = [];
    this.list = ko.observableArray([]);
    this.search_query = ko.observable('');

    this.search = function () {
        if (self.search_query().trim().length == 0) {
            self.list(full_list);
            return;
        }

        var query = self.search_query().trim();

        self.list(full_list.filter(function (item) {
            return item.search(query);
        }));
    };

    this.fill = function (data) {
        self.clean();
        full_list = [];

        if (!data || data.length == 0) return;

        data.forEach(function (item) {
            var quote = new Quote(item);
            full_list.push(quote);
        });

        self.list(full_list);
    };

    this.refresh = function () {
        function callback(status, data) {
            if (!status) return;

            self.fill(data);
        }

        self.api.get(callback);
    };

    this.clean = function () {
        self.list([]);
    };

    this.cleanSearchForm = function () {
        self.search_query('');
    };

    this.init = function (data) {
        self.fill(data);
    };

    this.api = {
        get: function (callback) {
            preloader.show('get-quotes');
            $.ajax({
                url: 'rest.php/quotes',
                method: 'GET',
                dataType: 'json'
            }).done(function (resp) {
                if (callback) callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('get-quotes');
            });
        }
    }
};

module.exports = new Quotes();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ExistingOrders/quotes.js
// module id = 10
// module chunks = 0